module.exports = __webpack_public_path__ + "img/_bar2.9d02e5ee.png";